// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.4.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1778659222793';
export const BUILD_DATE = '2026-05-13T08:00:22.793Z';
/* tslint:enable */
